export default "/images/framework/MyRankingEng.0c8772ba.svg?0c8772ba";